const normalizeValue = value => {
  if (value === null || value === undefined) {
    return '';
  }
  return String(value).trim();
};

const ADDRESS_FIELDS = [
  ['streetAddress', 'streetAddress'],
  ['apartment', 'apartment'],
  ['city', 'city'],
  ['state', 'state'],
  ['zipCode', 'zipCode'],
  ['county', 'county'],
  ['homeless', 'homeless']
];

export default (otherInfo = {}, linkedGuest) => {
  if (!linkedGuest) {
    return true;
  }

  return ADDRESS_FIELDS.every(
    ([portalField, guestField]) =>
      normalizeValue(otherInfo[portalField]) ===
      normalizeValue(linkedGuest[guestField])
  );
};
